// extracted by mini-css-extract-plugin
module.exports = {"controls":"App_controls__14oJX","layout":"App_layout__1LipR","legend":"App_legend__oZ4U8"};